define('AwaLabs.HashScroll.Module', [
    'Utils',
    'jQuery',
    'underscore',
    'Backbone'
],
function (
	Utils,
	jQuery,
	_,
	Backbone
) {
    'use strict';

    return {
        paramName: 'target',
        animated: true,

        mountToApp: function mountToApp(application) {
            var Layout = application.getLayout();

            var paramName = this.paramName;
            var animated = this.animated;

            function gotoToId(f) {
                var $el = Layout.$('#' + f);

                if (!$el.length) {
                    $el = Layout.$('.' + f);
                }
                if ($el.length) {
                    _.defer(function fn() {
                        var top = $el.offset().top - 25;
                        jQuery('html, body').animate({
                            scrollTop: top
                        }, 500);
                    });
                }
            }

            function gotoElement(e) {
                var $el = jQuery(e.currentTarget);
                var url = Backbone.history.fragment;
                var data = $el.data();

                url = url.split('?')[0] + '?' + jQuery.param(_.extend(url.indexOf('?') > -1 ? _.parseUrlOptions(Backbone.history.fragment) : {}, {
                    'goto': data.goto
                }));
                Backbone.history.navigate(url);
                gotoToId(data.goto);
            }

            Layout.events = _.extend(Layout.events, {
                'click [data-goto]': gotoElement
            });

            Layout.on('afterAppendView', function afterAppendView(view) {
                var urlOptions;
                var param;
                var $target;

                if (view === Layout.currentView) {
                    urlOptions = Utils.parseUrlOptions(Backbone.history.fragment);
                    param = urlOptions[paramName];
                    CMS.on('page:content:set', function pageContentSet() {
                        if (param) {
                            $target = Layout.$('#' + param);
                            if (!$target.length) {
                                $target = Layout.$('[name="' + param + '"]');
                            }
                            if (!$target.length) {
                                $target = Layout.$('.' + param).eq(0);
                            }
                            if ($target.length) {
                                if (!Utils.isPageGenerator()) {
                                    setTimeout(function timeout() {
                                        var offset = $target.offset().top - 25;
                                        if (animated) {
                                            jQuery('html, body').animate({
                                                scrollTop: offset
                                            }, 500);
                                        } else {
                                            jQuery('html, body').scrollTop(offset);
                                        }
                                    }, 1000);
                                }
                            }
                        }
                    });
                }
            });
        }
    };
});
